import { isWeChatDevTools, loadScript } from './util'

const vConsole = 'https://cdn.bootcdn.net/ajax/libs/vConsole/3.15.1/vconsole.min.js'
const eruda = 'https://cdn.bootcdn.net/ajax/libs/eruda/3.2.1/eruda-polyfill.min.js'

;(function initDebugTool() {
  const inspect = document.cookie.includes('inspect=true')

  if (location.href.includes('draftMode=1')) {
    return
  }

  // 如果不需要调试工具，直接返回
  if (isWeChatDevTools()) {
    return
  }
  if (!inspect) {
    if (!process.env.VUE_APP_DEBUG_TOOL) {
      return
    }
  }
  // 根据环境配置加载对应的调试工具
  switch (process.env.VUE_APP_DEBUG_TOOL) {
    case 'eruda':
      loadScript(eruda, {
        onload: () => window.eruda.init()
      })
      break
    case 'vconsole':
      loadScript(vConsole, {
        onload: () => new window.VConsole()
      })
      break
    default:
      inspect ?? loadScript(vConsole, {
        onload: () => new window.VConsole()
      })
      break
  }
})();

(function setInspectCookie() {
  // 仅允许在预发环境设置 inspect
  if (process.env.VUE_APP_BUILD_ENV === 'pre') {
    if (location.href.includes('?inspect=true') && !document.cookie.includes('inspect=true')) {
      // 有效期 3 天
      const THREE_DAYS_IN_SECONDS = 3 * 24 * 60 * 60
      document.cookie = `inspect=true; path=/; max-age=${THREE_DAYS_IN_SECONDS}`
    } else if (location.href.includes('?inspect=false') && document.cookie.includes('inspect=true')) {
      document.cookie = 'inspect=false; path=/; max-age=0'
    }
  }
})()
